import { render } from "./EndpointItem.vue?vue&type=template&id=1f268409&scoped=true&ts=true"
import script from "./EndpointItem.vue?vue&type=script&lang=ts"
export * from "./EndpointItem.vue?vue&type=script&lang=ts"

import "./EndpointItem.vue?vue&type=style&index=0&id=1f268409&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f268409"]])

export default __exports__